import { Card, CardContent } from "@/components/ui/card";

interface IframeSkeletonProps {
  height?: string;
  className?: string;
}

export function IframeSkeleton({ height = "800px", className = "" }: IframeSkeletonProps) {
  return (
    <Card className={`w-full ${className}`} style={{ height }}>
      <CardContent className="p-6 h-full">
        <div className="animate-pulse h-full flex flex-col space-y-6">
          {/* Form Header */}
          <div className="space-y-3">
            <div className="h-8 bg-gray-200 rounded-lg w-3/4"></div>
            <div className="h-4 bg-gray-200 rounded w-full"></div>
            <div className="h-4 bg-gray-200 rounded w-5/6"></div>
          </div>

          {/* Form Fields */}
          <div className="space-y-4 flex-1">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div className="space-y-2">
                <div className="h-4 bg-gray-200 rounded w-1/3"></div>
                <div className="h-10 bg-gray-200 rounded-lg"></div>
              </div>
              <div className="space-y-2">
                <div className="h-4 bg-gray-200 rounded w-1/2"></div>
                <div className="h-10 bg-gray-200 rounded-lg"></div>
              </div>
            </div>

            <div className="space-y-2">
              <div className="h-4 bg-gray-200 rounded w-1/4"></div>
              <div className="h-10 bg-gray-200 rounded-lg"></div>
            </div>

            <div className="space-y-2">
              <div className="h-4 bg-gray-200 rounded w-1/3"></div>
              <div className="h-10 bg-gray-200 rounded-lg"></div>
            </div>

            <div className="space-y-2">
              <div className="h-4 bg-gray-200 rounded w-1/4"></div>
              <div className="h-24 bg-gray-200 rounded-lg"></div>
            </div>

            <div className="space-y-2">
              <div className="h-4 bg-gray-200 rounded w-1/3"></div>
              <div className="h-20 bg-gray-200 rounded-lg"></div>
            </div>
          </div>

          {/* Submit Button */}
          <div className="pt-4">
            <div className="h-12 bg-blue-200 rounded-lg w-full"></div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}